/* Restore the existing Share this flag destination when the optional social section is absent. */
(() => {
  if (document.body.dataset.exoPageShell !== 'gameday' || document.getElementById('gameday-social-share')) return;
  const slot = document.querySelector('[data-authentic-share-slot]');
  if (!slot || !document.querySelector('a[href="#gameday-social-share"]')) return;
  slot.id = 'gameday-social-share';
  slot.setAttribute('data-gameday-social-share', '');
  const button = document.createElement('button');
  button.type = 'button'; button.textContent = 'Share this flag';
  button.className = 'gameday-authentic-personalizer__save';
  const status = document.createElement('p');
  status.setAttribute('role', 'status');
  button.addEventListener('click', async () => {
    const url = new URL(location.href); url.hash = '';
    try {
      if (navigator.share) await navigator.share({ title: document.title, url: url.href });
      else { await navigator.clipboard.writeText(url.href); status.textContent = 'Flag link copied.'; }
    } catch (error) {
      if (error.name !== 'AbortError') { status.textContent = 'Copy this flag link: ' + url.href; }
    }
  });
  slot.append(button, status);
  if (location.hash === '#gameday-social-share') slot.scrollIntoView();
})();
